const dashboardTimeframes = ['Last Week', 'Current Week'] as const;
export type DashboardTimeframes = (typeof dashboardTimeframes)[number];
export const timesframes: DashboardTimeframes[] = [...dashboardTimeframes];

export const bussinessMetricsSort = ['Net Sales', 'Cost of Goods Sold', 'Total Labor', 'Prime Cost'] as const;
export type BussinessMetricsTypes = (typeof bussinessMetricsSort)[number];
export const bussinesMetrics: BussinessMetricsTypes[] = [...bussinessMetricsSort];
